import { jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Watermark } from 'antd';
import { useSelector } from 'react-redux';
const WatermarkComponent = ({ color = '#f9cde0', zIndex = 11, gap = [80, 20], offset, fontSize = 11, rotate = -5, children }) => {
    var _a, _b;
    const applicationData = useSelector((state) => state.applicationData);
    const [content, setContent] = useState();
    useEffect(() => {
        var _a, _b;
        setContent((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmailId);
    }, [(_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmailId]);
    const watermarkProps = {
        content,
        zIndex,
        rotate,
        gap,
        offset,
        font: { color: typeof color === 'string' ? color : color, fontSize }
    };
    return (_jsxs(Watermark, Object.assign({}, watermarkProps, { children: [children, "  "] })));
};
export default WatermarkComponent;
